// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";

import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    image: logoCT,
    route: "/inicio",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "",
    },
    {
      icon: <TwitterIcon />,
      link: "",
    },
  ],
  menus: [
    {
      name: "Enlaces",
      items: [
        { name: "Teléfono: 74 3741 0373", href: "tel:7437410373" },
        { name: "Dirección: VILLA DE TEZONTEPEC CENTRO, HIDALGO, CP 43880", href: "" },
        { name: "https://www.bombasares.com.mx/", href: "https://www.bombasares.com.mx/" },
      ],
    },
     {
      name: "Otros Recursos",
      items: [
        { name: "Aviso de privacidad", route: "/privacidad" },
        { name: "Datos sensibles", route: "/sensibles" },
        { name: "Politica de cancelación", route: "/cancelacion" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Copyright &copy; {date}
      <MKTypography
        fontWeight="regular"
      >
        ARES
      </MKTypography>
      .
    </MKTypography>
  ),
};
